(function ($) {

    "use strict";

    const init = function () {
        if (document.querySelector('header')) {
            smartHeader('header', 90);
        }
        collapseNavInSmallView('75em');
        toggleNav();
        hideNavByTopNavLink();
        lang();
        if (document.querySelector('.header .nav__menu')) {
            setClsIfElementScrolledDown('.header .nav__menu');
        }
        heroSlider();
        logoSlider();
        sumoSelect();
        characterCount();
        setBoxHeightOfElements();

    };

    const smartHeader = function (clsHeader, offsetToMiniHeader) {

        let header, clsHeaderMini, clsHeaderVisible, clsHeaderSmart, position, scroll, topNavActive, scrollOptions;

        clsHeader = clsHeader || 'header';
        header = document.querySelector('.' + clsHeader);
        offsetToMiniHeader = offsetToMiniHeader || header.offsetHeight;
        clsHeaderMini = clsHeader + '--mini';
        clsHeaderVisible = clsHeader + '--visible';
        clsHeaderSmart = clsHeader + '--smart';
        position = getWindowScrollY();
        scrollOptions = {
            // hide header
            down: function () {
                if (getWindowScrollY() > offsetToMiniHeader) {
                    header.classList.remove(clsHeaderVisible);
                }
            },
            // show header
            up: function () {
                header.classList.add(clsHeaderVisible);
            }
        };

        function getWindowScrollY() {
            return window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        }

        function setHeaderDisplay(args) {

            scroll = getWindowScrollY();
            topNavActive = document.body.classList.contains('toggle-navigation-active');

            if (scroll > position) {
                if (!topNavActive) {
                    args.down();
                }
            } else {
                args.up();
            }

            position = scroll;
        }

        function scrollHandler() {

            setHeaderDisplay(scrollOptions);

            if (getWindowScrollY() <= offsetToMiniHeader) {
                header.classList.remove(clsHeaderMini);
            } else {
                header.classList.add(clsHeaderMini);
            }
        }

        if (!header.classList.contains(clsHeaderSmart)) header.classList.add(clsHeaderSmart);
        if (!header.classList.contains(clsHeaderVisible)) header.classList.add(clsHeaderVisible);

        scrollHandler();
        window.addEventListener('scroll', scrollHandler);
    };

    const collapseNavInSmallView = function (size) {

        let mq, cls;

        cls = 'toggle-navigation-active';

        function removeCheckedState() {

            mq = window.matchMedia('(min-width: ' + size + ')');

            if (mq.matches) {
                document.body.classList.remove(cls);
            }
        }

        removeCheckedState(size);
        window.addEventListener('resize', function () {
            removeCheckedState(size);
        });
    };

    const hideNavByTopNavLink = function () {

        const btns = document.querySelectorAll('.menu-item a');

        if (btns.length === 0) return;

        const cls = 'toggle-navigation-active';

        [].forEach.call(btns, function (btn) {

            btn.addEventListener('click', function () {
                document.body.classList.remove(cls);
            });
        });
    };

    const toggleNav = function () {
        const $toggleBtn = $('.js-toggle-navigation');

        $toggleBtn.on('click', function () {
            $('body').toggleClass('toggle-navigation-active');
        });
    };

    const lang = function () {
        const $el = $('[data-toggle="dropdown"]');

        $el.on('click', function (event) {
            event.preventDefault();
            $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false' ? 'true' : 'false');

        });
    };

    const setClsIfElementScrolledDown = function (selector) {
        const cls = 'is-scrolled-down';
        const el = document.querySelector(selector);

        if (!el) return;

        function checkScroll() {
            if (el.scrollTop > 0) {
                el.classList.add(cls);
            } else {
                el.classList.remove(cls);
            }
        }

        el.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);

        checkScroll();
    };

    const heroSlider = function () {
        const $slider = $('.js-hero-slider');

        if ($slider.length === 0) return;

        // Get data attributes for autoplay and autoplay speed
        const autoplay = $slider.data('autoplay') === true || $slider.data('autoplay') === 1 || $slider.data('autoplay') === "true";
        const autoplaySpeed = $slider.data('autoplay-speed') ? parseInt($slider.data('autoplay-speed'), 10) : 5000; // default to 5000ms

        var mySwiper = new Swiper('.js-hero-slider', {
            direction: 'horizontal',
            loop: true,
            spaceBetween: 0,
            pagination: {
                el: '.js-hero-slider-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.js-hero-slider-next',
                prevEl: '.js-hero-slider-prev',
            },
            autoplay: autoplay ? {
                delay: autoplaySpeed,
                disableOnInteraction: false
            } : false
        });
    };


    const logoSlider = function () {

        if ($('.js-logo-slider').length === 0) return;

        var swiper = new Swiper('.js-logo-slider', {
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 40,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 80,
                },
            },
            loop: true,
            navigation: {
                nextEl: '.js-logo-slider-next',
                prevEl: '.js-logo-slider-prev',
            },
            pagination: {
                el: '.js-logo-slider-pagination',
                clickable: true,
            },
        });
    };

    const sumoSelect = function () {
        var options = {};
        const $el = $('.js-select-box');

        if ($el.length === 0) return;

        $el.each(function () {
            let itemsLen = $(this).find('option').length;
            if (itemsLen > 10) {
                options = {
                    search: true,
                    searchText: ''
                }
            }
        });

        $el.SumoSelect(options);

        if ($el.hasClass('js-select-box-navigation')) {
            $el.on('change', function () {
                window.location.href = this.value
            });
        }
    };

    const characterCount = function () {

        const $el = $('.js-char-cnt');

        if ($el.length === 0) return;

        $el.each(function () {

            let $this = $(this);

            const $currentEl = $this.closest('.form-row').find('.js-char-current');

            function updateCharacterCount() {
                $currentEl.text($this.val().length);
            }

            $this.on('input paste', updateCharacterCount);

            updateCharacterCount();
        });
    };

    window.setBoxHeightOfElements = function () {
        const $els = $('.js-box-title-height.js-box-body-height');

        if ($els.length === 0) return;

        function setHeights() {
            $els.each(function () {
                let $that = $(this);
                let $elTitle = $that.find('.js-box-title');
                let $elBody = $that.find('.js-box-body');
                $that.css('--box-title-height', $elTitle.height() + 'px');
                $that.css('--box-body-height', $elBody[0].scrollHeight + 'px');
            });
        }

        setHeights();

        $(window).on('resize', setHeights);
    };


    class Accordion {
        constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element
            this.content = el.querySelector('.js-accordion-content');

            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
        }

        onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
                this.open();
                // Check if the element is being openned or is already open
            } else if (this.isExpanding || this.el.open) {
                this.shrink();
            }
        }

        shrink() {
            // Set the element as "being closed"
            this.isClosing = true;

            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the height of the summary
            const endHeight = `${this.summary.offsetHeight}px`;

            // If there is already an animation running
            if (this.animation) {
                // Cancel the current animation
                this.animation.cancel();
            }

            // Start a WAAPI animation
            this.animation = this.el.animate({
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            }, {
                duration: 400,
                easing: 'ease-out'
            });

            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
        }

        open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
        }

        expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            // Get the current fixed height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

            // If there is already an animation running
            if (this.animation) {
                // Cancel the current animation
                this.animation.cancel();
            }

            // Start a WAAPI animation
            this.animation = this.el.animate({
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            }, {
                duration: 400,
                easing: 'ease-out'
            });
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
        }

        onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
        }
    }


    document.addEventListener("DOMContentLoaded", function () {
        // Get all ghost__link elements
        const links = document.querySelectorAll(".js-shine-animation");

        // Check if there are any links
        if (links.length > 0) {

            // Function to randomly add the shine class
            function triggerShine() {
                // Remove shine from all elements
                links.forEach(link => link.classList.remove("shine"));

                // Select a random link
                const randomIndex = Math.floor(Math.random() * links.length);
                const randomLink = links[randomIndex];

                // Add the shine class
                randomLink.classList.add("shine");

                // Remove the shine effect after 5 seconds (same as the CSS animation duration)
                setTimeout(() => {
                    randomLink.classList.remove("shine");
                }, 5000);
            }

            // Run the function initially
            triggerShine();

            // Repeat the process every 8 seconds (or adjust timing as needed)
            setInterval(triggerShine, 2000);
        }
    });




    $(function () {
        if ($('[contenteditable="true"]').length) {
            $('[contenteditable="true"]').attr('contenteditable', 'false');
        }


        init();
        Fancybox.defaults.Hash = false;
        Fancybox.bind("[data-fancybox]", {
            Thumbs: {
                type: "classic",
            },
            Toolbar: {
                display: {
                    left: ["infobar"],

                    right: ["close"],
                },
            },

        });


        document.querySelectorAll('details').forEach((el) => {
            new Accordion(el);
        });


        $('.youtube-player').on('click', function () {
            var videoId = $(this).data('id');
            var iframe = `<iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&enablejsapi=1" 
                          frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
            $(this).html(iframe);
        });

        const $dateInput = $('#date'); // Select the date input using jQuery
        if ($dateInput.length) { // Check if the date input exists
            const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format
            $dateInput.attr('min', today); // Set the min attribute
        }



    });

})(jQuery); 